import { OptimizelyFeatureFlags } from 'constants/optimizely'
import type { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { initialOfferPageRooms } from 'contexts/OfferPage/offerPageStateReducer'
import { isLEHotel } from 'lib/offer/offerTypes'
import { createSelector } from 'reselect'
import { getIsMultiRoomEnabled } from '../featuresSelectors'

/**
 * Returns whether multiple room booking is active or not.
 * This includes the related feature flags and other variables that go into it
 */
export const isMultipleRoomBookingActive = createSelector(
  (state: OfferPageState) => state.rooms ?? initialOfferPageRooms,
  (state: OfferPageState, appState: App.State) => !state.bundleOffer && (isLEHotel(state.offer) || !!state.bedbankOffer) && getIsMultiRoomEnabled(appState, state.offer ?? state.bedbankOffer),
  (state: OfferPageState) => state.multiRoomMode,
  (rooms, isMultiRoomEnabled, multiRoomMode) => {
    return isMultiRoomEnabled && rooms.length > 1 && multiRoomMode === 'individual'
  },
)

export const isSppMultipleRoomBookingActive = createSelector(
  (state: OfferPageState) => state.rooms ?? initialOfferPageRooms,
  (state: OfferPageState) => !!state.property,
  (state: OfferPageState, appState: App.State) => !!appState.system.features.flags[OptimizelyFeatureFlags.sppMultiIndividualRoom],
  (state: OfferPageState) => state.multiRoomMode,
  (rooms, hasProperty, isSppMultiIndividualRoomEnabled, multiRoomMode) => {
    return isSppMultiIndividualRoomEnabled && hasProperty && rooms.length > 1 && multiRoomMode === 'individual'
  },
)
